<template>
    <div>
        <v-layout row wrap>
            <h1>Login</h1>
            <br>
            <v-container>
                <v-text-field
                    v-model="username"
                    label="Nome utente"
                    type="text"
                />
                <v-text-field
                    v-model="password"
                    label="Password"
                    type="password"
                />
                <br><br>
                <v-btn color="primary" text class="login-button" @click="login">
                    Accedi
                </v-btn>
                <br><br>
            </v-container>
        </v-layout>
    </div>
</template>

<script>
const axios = require('axios').default;
export default {
    name: 'Login',
    components: {
    },
    data:function(){
        return {
            username: "",
            password: ""
        };
    },
    mounted: function(){
        let vm = this;
        vm.getCurrentSession();
    },
    methods:{
        getCurrentSession(){
            let vm = this;
            axios({
                method: "GET",
                url: vm.$API_BASE_URL + "getSession.php",
                headers: {
                    'Authentication-Token': window.localStorage.getItem("sogno_at")
                }
            })
            .then(function (response) {
                if (response.status == 200) {
                    vm.$router.push({name: 'home'});
                } else {
                    console.log("Nessuna sessione valida attiva");
                    window.localStorage.setItem("sogno_at", "");
                }
            })
            .catch(function (error) {
                console.log("Nessuna sessione valida attiva");
                window.localStorage.setItem("sogno_at", "");
            });
        },
        login() {
            let vm = this;
            vm.isLoading = true;
            if(vm.username.includes("@")){
                alert("Utilizzare il nome utente fornito, non un indirizzo mail");
                vm.isLoading = false;
                return;
            }
            vm.username = vm.username.trim();
            axios({
                method: "POST",
                url: vm.$API_BASE_URL + "user/login.php",
                data: "username=" + vm.username + "&password=" + vm.password,
            })
            .then(function (response) {
                if (response.status == 200) {
                    window.localStorage.setItem("sogno_at", response.data.token);
                    vm.$router.push({name: 'home'});
                } else {
                    alert("Utente o password non corretti");
                }
            })
            .catch(function (error) {
                alert("Utente o password non corretti");
            });
        },
        postSomething(){
            let vm = this;
            let bodyFormData = new FormData();
            bodyFormData.append('body', vm.newGiurisprudenzaBody);
            bodyFormData.append('title', vm.newGiurisprudenzaTitle);
            axios({
                method: 'POST',
                url: vm.$API_BASE_URL + 'create.php',
                data: bodyFormData,
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authentication-Token': window.localStorage.getItem("sogno_at")
                }
            })
            .then(function (response) {
                if (response.status === 200) {
                    alert("Giurisprudenza creata!");
                    vm.getAllGiurisprudenza();
                }
                else {
                    alert("Errore durante la creazione, riprova più tardi...");
                    console.error(response);
                }
            })
            .catch(function (error) {
                alert("Errore durante la creazione, riprova più tardi...");
                console.error(error);
            });
        }
    }
}
</script>

<style scoped>
    .login-button{
        width: 100%;
        margin: 0;
    }
</style>
